import { CSRF_HEADER, getCsrfToken } from "@/lib/csrf";
import { biteAdvertisingClick, clearBiteAdvertisingEntry } from './bite-entry';
import { browserTimeoutMs } from '../../../config/bite-advertising.json';

export interface AdvertisingConsent {
  available: boolean;
  decided: boolean;
  enabled: boolean;
  version: number;
}

async function request(path: string, body?: Record<string, unknown>) {
  const response = await fetch(`/api/bite/advertising/${path}`, {
    credentials: "same-origin",
    cache: "no-store",
    signal: AbortSignal.timeout(browserTimeoutMs),
    ...(body ? { method: "POST", headers: { "Content-Type": "application/json", [CSRF_HEADER]: await getCsrfToken() }, body: JSON.stringify(body) } : {}),
  });
  if (!response.ok) throw new Error("광고 측정 동의를 저장하지 못했습니다. 다시 시도해주세요.");
  return response.status === 204 ? undefined : response.json();
}

let pending = Promise.resolve<unknown>(undefined);
function enqueue<T>(operation: () => Promise<T>): Promise<T> {
  const result = pending.catch(() => undefined).then(operation);
  pending = result;
  return result;
}
export async function getAdvertisingConsent(): Promise<AdvertisingConsent> {
  return request("consent");
}
export function setAdvertisingConsent(enabled: boolean, version: number): Promise<AdvertisingConsent> {
  if (!enabled) clearBiteAdvertisingEntry();
  const fbclid = enabled ? biteAdvertisingClick() : undefined;
  return enqueue(() => request("consent", { enabled, version, ...(enabled ? { fbclid } : {}) }));
}
export const captureAdvertisingVisit = () => enqueue(() => request("visit", { fbclid: biteAdvertisingClick() }));
export async function prepareBiteAdvertising() {
  return enqueue(async () => {
    const consent = await getAdvertisingConsent();
    if (consent.decided && !consent.enabled) clearBiteAdvertisingEntry();
    if (consent.enabled) await request("visit", { fbclid: biteAdvertisingClick() });
  });
}
